import React from 'react'
import classes from "./Service.module.css"
import serviceHero from "../../assets/service-hero.svg"
import home from "../../assets/home.svg"
import ellipse  from "../../assets/elipse.svg"
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
import { useNavigate } from "react-router-dom";



export const Service = () => {
  
const navigate = useNavigate();
const handleVerifyTcc = () => {
  navigate("/service/verify_tcc");
};
const handleValidate = () => {
  navigate("/service/validate_account");
};

  return (
    <div>
      <Header />
    <div className={classes.topAbout}>
<div className={classes.serviceAll}>
  <div className={classes.textTop}>
    <h4 className={classes.serviceTxt}>Our <br /> <span className={classes.srvc}>SERVICES</span></h4>
      <p className={classes.subWlc}>Empowering taxpayers of Ogun State to meet their obligations with ease, efficiency, and professional support through comprehensive digital solutions, accessible services, and dedicated assistance designed to simplify every aspect of your tax journey</p>
     <img src={ellipse} alt='ellipse' className={classes.ellipse}/>
  </div>
  
  <div className={classes.heroimg}>
    <img src={serviceHero} alt='service-hero' className={classes.servicehero} />
  </div>
</div>

<div className={classes.sndDiv}>
  <h4 className={classes.compTxt}>Comprehensive Tax  Solutions in One Place</h4>
  <div className={classes.gridTax}>
  <div className={classes.taxDiv}>
    <div className={classes.bgBg}>
<img src={home}/>
    </div>
      <h4 className={classes.taxTxt}>Corporate Tax Services</h4>
<p  className={classes.taxDesc}>Tax drives development by funding essential  infrastructure and services across Ogun State</p>
<button className={classes.rgBtn}>Register as Corporate</button>
  </div>
  <div className={classes.taxDiv}>
    <div className={classes.bgBg}>
<img src={home}/>
    </div>
      <h4 className={classes.taxTxt}>Individual Tax Services</h4>
<p  className={classes.taxDesc}>Your taxes build roads, schools, and healthcare - investing in Ogun State's future together</p>
<button className={classes.rgBtn}>Register as an Individual</button>
  </div>
  <div className={classes.taxDiv}>
    <div className={classes.bgBg}>
<img src={home}/>
    </div>
      <h4 className={classes.taxTxt}>Verify TCC</h4>
<p  className={classes.taxDesc}>Instantly verify Tax Clearance Certificates for secure business transactions and compliance assurance</p>
    <button 
    className={classes.rgBtn} 
    onClick={handleVerifyTcc}
    >Verify your TCC
    </button>
  </div>
  <div className={classes.taxDiv}>
    <div className={classes.bgBg}>
<img src={home}/>
    </div>
      <h4 className={classes.taxTxt}>Access Tax Portal</h4>
<p  className={classes.taxDesc}>File returns, make payments, download reports, and manage your tax activities from a single secure platform</p>
<button className={classes.rgBtn}>Portal</button>
  </div>
  <div className={classes.taxDiv}>
    <div className={classes.bgBg}>
<img src={home}/>
    </div>
      <h4 className={classes.taxTxt}>Validate Account</h4>
<p  className={classes.taxDesc}>Update and confirm your taxpayer account status using your Tax Identification Number</p>
    <button 
    className={classes.rgBtn}
     onClick={handleValidate}
    >Validate your Account
    </button>
  </div>

  </div>
</div>
            <Footer />
    </div>
    </div>
  )
}
